import { render, staticRenderFns } from "./RegistrationPromotion.vue?vue&type=template&id=34e56b3f&scoped=true"
import script from "./RegistrationPromotion.vue?vue&type=script&lang=js"
export * from "./RegistrationPromotion.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPromotion.vue?vue&type=style&index=0&id=34e56b3f&prod&lang=scss&scoped=true"
import style1 from "./RegistrationPromotion.vue?vue&type=style&index=1&id=34e56b3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e56b3f",
  null
  
)

export default component.exports